import moment from "moment";
import { COMPARE_PERIODS_ENUM } from "@/enums/comparePeriods.enum";
import { PERIOD } from "@/enums/period.enum";

export class MakePeriodDate {
  constructor() {
    this.periodFrom = null;
    this.periodTo = null;
    this.period = [];
    this.periodGroup = null;
    this.comparePeriodFrom = null;
    this.comparePeriodTo = null;
    this.comparePeriod = [];
    this._daysDiff = null;
  }

  createDate({ dateFrom, dateTo }) {
    if (dateFrom && dateTo) {
      const datesSorted = this._sortDate({ dateFrom, dateTo });
      this._setPeriod(datesSorted);
      this._setPeriodAsArray();
      this._countPeriodDiff();
      this._setPeriodGroup();
      return;
    }
    this._setDefaultPeriod();
    this._setPeriodAsArray();
    this._countPeriodDiff();
    this._setPeriodGroup();
  }

  createDateWithCompare({ dateFrom, dateTo, compareEnum }) {
    if (dateFrom && dateTo) {
      const datesSorted = this._sortDate({ dateFrom, dateTo });
      this._setPeriod(datesSorted);
      this._setPeriodAsArray();
      this._countPeriodDiff();
      this._setPeriodGroup();
      this._makeCompareDates(compareEnum);
      return;
    }
    this._setDefaultPeriod();
    this._setPeriodAsArray();
    this._countPeriodDiff();
    this._setPeriodGroup();
    this._makeCompareDates(compareEnum);
  }

  returnPeriod() {
    return {
      dateFrom: this.periodFrom,
      dateTo: this.periodTo,
      period: this.period,
      group: this.periodGroup
    };
  }

  returnPeriodWithCompare() {
    return {
      dateFrom: this.periodFrom,
      dateTo: this.periodTo,
      period: this.period,
      group: this.periodGroup,
      compareDateFrom: this.comparePeriodFrom,
      compareDateTo: this.comparePeriodTo,
      comparePeriod: this.comparePeriod
    };
  }

  _setPeriod({ dateFrom, dateTo }) {
    if (!dateFrom || !dateTo) {
      this.periodFrom = null;
      this.periodTo = null;
      this.period = [];
      return;
    }
    this.periodFrom = moment(dateFrom).format("YYYY-MM-DD");
    this.periodTo = moment(dateTo).format("YYYY-MM-DD");
  }

  _setDefaultPeriod() {
    this.periodFrom = moment()
      .subtract(1, "month")
      .add(1, "day")
      .format("YYYY-MM-DD");
    this.periodTo = moment().format("YYYY-MM-DD");
  }

  _setPeriodAsArray() {
    this.period = [this.periodFrom, this.periodTo];
  }

  _sortDate({ dateFrom, dateTo }) {
    const momentDateFrom = moment(dateFrom);
    return momentDateFrom.isBefore(dateTo) || momentDateFrom.isSame(dateTo)
      ? { dateFrom, dateTo }
      : { dateFrom: dateTo, dateTo: dateFrom };
  }

  _countPeriodDiff() {
    this._daysDiff = moment(this.periodFrom).diff(this.periodTo, "day");
  }

  _setPeriodGroup() {
    if (this._daysDiff) {
      this.periodGroup = Math.abs(this._daysDiff) > 31 ? "month" : "day";
    }
  }

  _makeCompareDates(compareEnum) {
    switch (compareEnum) {
      case COMPARE_PERIODS_ENUM.COMPARE_WITH_PREVIOUS_PERIOD:
        this._setCompareWithPreviousPeriod();
        break;
      case COMPARE_PERIODS_ENUM.COMPARE_WITH_PREVIOUS_YEAR:
        this._setCompareWithPreviousYear();
        break;
    }
  }

  _setCompareWithPreviousPeriod() {
    this.comparePeriodFrom = moment(this.periodFrom)
      .subtract(Math.abs(this._daysDiff) + 1, PERIOD.DAYS)
      .format("YYYY-MM-DD");
    this.comparePeriodTo = moment(this.periodTo)
      .subtract(Math.abs(this._daysDiff) + 1, PERIOD.DAYS)
      .format("YYYY-MM-DD");
    this.comparePeriod = [this.comparePeriodFrom, this.comparePeriodTo];
  }

  _setCompareWithPreviousYear() {
    this.comparePeriodFrom = moment(this.periodFrom)
      .subtract(1, PERIOD.YEAR)
      .format("YYYY-MM-DD");
    this.comparePeriodTo = moment(this.periodTo)
      .subtract(1, PERIOD.YEAR)
      .format("YYYY-MM-DD");
    this.comparePeriod = [this.comparePeriodFrom, this.comparePeriodTo];
  }
}
